// FirebaseContext.js
import React, { createContext, useContext, useState, useEffect } from "react";
import firebaseInstance from "../utils/firebase";

const FirebaseContext = createContext(null);

export const FirebaseProvider = ({ children }) => {
  const [db, setDb] = useState(null);
  const [isInitializing, setIsInitializing] = useState(true);

  useEffect(() => {
    // Initialize Firestore from the singleton instance
    setDb(firebaseInstance.getDb());
    setIsInitializing(false); // Mark initialization as complete
  }, []);

  if (isInitializing) {
    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 2000,
        }}
      >
        <p style={{ color: "white", fontSize: "18px" }}>Loading...</p>
      </div>
    );
  }

  return (
    <FirebaseContext.Provider value={{ db }}>
      {children}
    </FirebaseContext.Provider>
  );
};

// Custom hook for accessing Firebase
export const useFirebase = () => useContext(FirebaseContext);
